/**
 * The 0–10 ICP qualify fit score as every surface shows it — "fit 7/10"
 * (POS-2498). One formatter so the staging row, the switch tooltip and the
 * sequence event reason cannot drift apart.
 */
export function formatQualifyFit(fit: number): string {
  return `fit ${fit}/10`;
}
